import { render, staticRenderFns } from "./PurchaseOrdersList.vue?vue&type=template&id=22a29454&scoped=true&"
import script from "./PurchaseOrdersList.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrdersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a29454",
  null
  
)

export default component.exports